<script lang="ts">
  interface Props {
    lang?: string | null;
    title?: string | null;
    subTitle?: string | null;
    phoneLabel?: string | null;
    emailLabel?: string | null;
    customPhone?: string | undefined;
    customEmail?: string | undefined;
    showAddress?: boolean;
    class?: string;
    isBorettslag?: boolean;
    isLandbruk?: boolean;
    children?: import("svelte").Snippet;
  }

  let {
    lang = null,
    title = null,
    subTitle = null,
    phoneLabel = null,
    emailLabel = null,
    customPhone = undefined,
    customEmail = undefined,
    showAddress = true,
    class: classes = "",
    isBorettslag = false,
    isLandbruk = false,
    children,
  }: Props = $props();

  let contactPhone = $derived(customPhone ?? "776 12 000");
  let contactEmail = $derived(customEmail ?? "kunde@ishavskraft.no");
</script>

<section class="info_container bg-$secondary-pink-200 rounded-2xl mx-edge-x {classes}" {lang}>
  <h2 class="hyphens-manual mb-0">{title || "Har du andre spørsmål, ta gjerne kontakt med oss"}</h2>
  {#if subTitle}
    <p class="text-body mt-2">{subTitle}</p>
  {/if}

  {@render children?.()}

  {#if showAddress}
    <address class="not-italic text-body children-my-0">
      {#if !isBorettslag && !isLandbruk}
        <p class="mb-2">
          {phoneLabel || "Ring oss på"}
          <a class="hyphens-manual" href="tel:{contactPhone}">{contactPhone}</a>
        </p>
      {/if}
      <p>
        {emailLabel || "Send oss en e-post på"}
        <a class="hyphens-manual" href="mailto:{contactEmail}">{contactEmail}</a>
      </p>
    </address>
  {/if}
</section>

<style>
  :where(section) {
    display: flex;
    flex-direction: column;
    margin-block-end: var(--s-12);
    padding: var(--s-4) var(--s-3);
  }

  @media (--tablet) {
    :where(section) {
      padding: var(--s-4) var(--s-5);
    }
  }

  a {
    font-weight: 600;
  }
</style>
